import { createAction } from '@reduxjs/toolkit';

export const openImageViewer = createAction<string>('app/imageViewer/open');
export const closeImageViewer = createAction('app/imageViewer/close');
